import { FC, ReactNode, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";

import { ROUTES } from "constants/routes";

import Logo from "icons/Logo";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";

import AuthLayoutImg from "images/auth-layout-img.jpeg";

import { Button } from "components/common/Button";

import {
  StyledAuthLayout,
  StyledAuthLayoutContentContainer,
  StyledAuthLayoutHeader,
  StyledAuthLayoutHeaderLogo,
  StyledAuthLayoutImgContainer,
  StyledAuthLayoutMainContainer,
} from "styles/layouts/AuthLayout";

interface AuthLayoutProps {
  backRoute?: string;
  children: ReactNode;
  centered?: boolean;
}

const AuthLayout: FC<AuthLayoutProps> = ({
  backRoute,
  children,
  centered = true,
}) => {
  const navigate = useNavigate();

  const handleBack = useCallback(
    () => backRoute && navigate(backRoute),
    [backRoute, navigate]
  );

  const contentContainerClassName = clsx([
    "auth-layout-content-container",
    { "auth-layout-content-container_centered": centered },
  ]);

  const renderedBackButton = useMemo(
    () =>
      backRoute && (
        <Button
          variant="text"
          startIcon={<ChevronLeftOutlinedIcon />}
          onClick={handleBack}
        >
          Go Back
        </Button>
      ),
    [backRoute, handleBack]
  );
  return (
    <StyledAuthLayout className="auth-layout">
      <StyledAuthLayoutMainContainer className="auth-layout-main-container">
        <StyledAuthLayoutHeader className="auth-layout-header">
          <StyledAuthLayoutHeaderLogo to={ROUTES.home}>
            <Logo />
          </StyledAuthLayoutHeaderLogo>
          {renderedBackButton}
        </StyledAuthLayoutHeader>
        <StyledAuthLayoutContentContainer className={contentContainerClassName}>
          {children}
        </StyledAuthLayoutContentContainer>
      </StyledAuthLayoutMainContainer>
      <StyledAuthLayoutImgContainer className="auth-layout-img-container">
        <img
          src={AuthLayoutImg}
          alt="auth-layout-img"
          className="auth-layout__img"
        />
      </StyledAuthLayoutImgContainer>
    </StyledAuthLayout>
  );
};

export default AuthLayout;
